export class BaseError extends Error {
  constructor(
    message: string,
    public code: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = this.constructor.name;
    Error.captureStackTrace(this, this.constructor);
  }
}

export const isBaseError = (error: unknown): error is BaseError =>
  error instanceof BaseError;
